import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useTheme} from "@mui/styles";
import SkillView from "bundles/Recruiter/components/SkillView";
import { useSelector } from "react-redux";

const CandidateSkillsBlock = ({ candidate }) => {
  const theme = useTheme();
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const hard_skills =
    candidate?.skills?.filter(skill => skill.category == "hard") ||
    candidate?.hard_skills ||
    [];
  const soft_skills =
    candidate?.skills?.filter(skill => skill.category == "soft") ||
    candidate?.soft_skills ||
    [];
  const languages =
    candidate?.skills?.filter(skill => skill.category == "lang") ||
    candidate?.language_skills ||
    [];
  const software_skills =
    candidate?.skills?.filter(skill => skill.category == "software") ||
    candidate?.software_skills ||
    [];
  const licence_skills =
    candidate?.skills?.filter(skill => skill.category == "licence") ||
    candidate?.licence_skills ||
    [];

  return (
    <>
      {(hard_skills?.length > 0 || soft_skills?.length > 0 || languages?.length > 0 || software_skills?.length > 0 || licence_skills?.length > 0) && (
        <Paper sx={{ padding: "20px", marginTop: "20px", boxShadow: "none", borderRadius: "10px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {hard_skills?.length > 0 && (
              <>
                <Typography variant="h5" fontWeight="bold" sx={{ color: theme.palette.secondary.black }}>
                  <FormattedMessage id="candidate.hard_skills" defaultMessage="Hard skills" />
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {hard_skills?.map(skill => {
                    return <SkillView key={skill.id} value={skill} category="hard" level={false} locale={i18nLocale} />;
                  })}
                </Box>
              </>
            )}
            {soft_skills?.length > 0 && (
              <>
                <Typography variant="h5" fontWeight="bold" sx={{ color: theme.palette.secondary.black }}>
                  <FormattedMessage id="candidate.soft_skills" defaultMessage="Soft skills" />
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {soft_skills?.map(skill => {
                    return <SkillView key={skill.id} value={skill} category="soft" level={false} locale={i18nLocale} />;
                  })}
                </Box>
              </>
            )}
            {languages?.length > 0 && (
              <>
                <Typography variant="h5" fontWeight="bold" sx={{ color: theme.palette.secondary.black }}>
                  <FormattedMessage id="candidate.language_skills" defaultMessage="Language skills" />
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {languages?.map(skill => {
                    return <SkillView key={skill.id} value={skill} category="lang" level={false} locale={i18nLocale} />;
                  })}
                </Box>
              </>
            )}
            {software_skills?.length > 0 && (
              <>
                <Typography variant="h5" fontWeight="bold" sx={{ color: theme.palette.secondary.black }}>
                  <FormattedMessage id="candidate.software_skills" defaultMessage="Software" />
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {software_skills?.map(skill => {
                    return <SkillView key={skill.id} value={skill} category="software" level={false} locale={i18nLocale} />;
                  })}
                </Box>
              </>
            )}
            {licence_skills?.length > 0 && (
              <>
                <Typography variant="h5" fontWeight="bold" sx={{ color: theme.palette.secondary.black }}>
                  <FormattedMessage id="candidate.licence_skills" defaultMessage="Licences" />
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {licence_skills?.map(skill => {
                    return <SkillView key={skill.id} value={skill} category="licence" level={false} locale={i18nLocale} />;
                  })}
                </Box>
              </>
            )}
          </Box>
        </Paper>
      )}
    </>
  );
};

export default CandidateSkillsBlock;